import { Model } from 'pinia-orm';
import Job from './Job';
import JobJobChannel from './JobJobChannel';

export default class JobChannel extends Model {

    static entity = 'job-channels';

    static fields() {
        return {
            id: this.uid(),
            name: this.attr(null),
            company_id: this.attr(null),
            type: this.attr(null),
            url_type: this.attr(null),

            jobs: this.belongsToMany(Job, JobJobChannel, 'job_channel_id', 'job_id')
        }
    }

    // TEMPORARY; There is a bug in VueX ORM which made the pivot data apply to job_id only
    // This means if a job had 5 jobchannels, then the pivot data for all the 5 jobchannels would be the same (the last jobchannel)
    // Now we do the insertOrUpdate but afterwards manually update the pivot model
    //
    // Ref: https://github.com/vuex-orm/vuex-orm/issues/668#issuecomment-805861403
    static insertOrUpdate({ data }) {
        let promise = super.insertOrUpdate({ data }) // call parent's insertOrUpdate

        if (Array.isArray(data)) {
            let isJobsPivotIncluded = false
            data.forEach((item) => {
                if (item.jobs && item.jobs.length) { isJobsPivotIncluded = true }
            })

            if (isJobsPivotIncluded) { // check if pivot table is present
                const pivotData = data.map((jobChannel) => {
                    return jobChannel.jobs.map((job) => {
                        return {
                            job_id: job.id,
                            job_channel_id: jobChannel.id,
                            posted_at: job.pivot.posted_at,
                            url: job.pivot.url,
                            application_count: job.pivot.application_count
                        }
                    })
                });

                return JobJobChannel.insertOrUpdate({ data: pivotData ? pivotData.flat() : null }) // update right data, how it should be
            }
        }
        return promise;
    }
}
